<script>
  
    import Panzoom from '@panzoom/panzoom'
    
    import { onMount } from 'svelte'
    import { fly, fade } from 'svelte/transition'
    import { documents, signedDocuments, userActive } from '../store/documents'
    import { stepsStore } from '../store/stepsStore'
    import { postHeaders } from '../store/antiforgery'

    import Page from '../components/Page.svelte'
    import SignModal from '../components/SignModal.svelte'
    import ErrorCard from '../components/ErrorCard.svelte'
    import AppointmentCard from '../components/AppointmentCard.svelte'

    import * as pdfjs from 'pdfjs-dist'

    // Resolve the worker relative to this bundle's script URL so the worker is
    // loaded from the same origin/path as the component, regardless of where
    // the host page serves it from.
    pdfjs.GlobalWorkerOptions.workerSrc = `https://cdn.clinichq.com/assets/bulk-sign/build/pdf.worker.min.mjs`

    export let list
    export let baseUrl
    export let signedInPerson

    let canSign = false
    let openMenu = false

    let activeId = null
    let activeAppointment = null

    let loader = false
    let errorList = []

    // TODO: Refactor this code into separate file
    let mobileCheck = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) mobileCheck = true;})(navigator.userAgent||navigator.vendor||window.opera);

    const checkInputs = (e) => {

        const validList = []

        $documents.forEach((form) => {

            const tempList = []

            form.inputFields.filter( f => f.isRequired ).forEach( field => {

                tempList.push(!!field.value)

            })

            form.valid = tempList.every(val => val === true)
            validList.push(form.valid)
        
        })

        canSign = validList.every( val => val === true )

    }

    // Watch appointments changes - If all required fields in the
    // current appointment are valid update appointment valid status
    // If all required fields in all forms are valid update canSign bool

    $: if ( $documents ) checkInputs()
            
    // Set active appointment

    const setActive = async (id) => {

      activeId = id
      activeAppointment = $documents.find( d => d.id === activeId )

      await getPdf(activeAppointment.fileUrl)

    }

    // Get page properties and calibrate inputs sizes

    let docW = 0
    let docH = 0

    const getProperties = () => {

        const form = document.getElementsByClassName('docs-canvas-content')[0]

        const formW = form.clientWidth
        const formH = form.clientHeight

        docW = formW
        docH = formH

    }

    const calibrate = (val, ref, target) => {

        return val / ref * target

    }

    // Input types

    const inputTypes = [
        {
            id: 1,
            type: 'text',
            name: 'Signature'
        },
        {
            id: 2,
            type: 'text',
            name: 'Text'
        },
        {
            id: 3,
            type: 'checkbox',
            name: 'Checkbox'
        },
        {
            id: 4,
            type: 'text',
            name: 'Date'
        }
    ]

    // Switch between inputs on click

    let inputs = []
    let lastActiveInput = 0

    $: if ( activeId ) {

        getInputs()

    }

    const getInputs = () => {

      inputs = [].slice.call(document.querySelectorAll('.input'))

      inputs.forEach((field, index) => {
          field.setAttribute( 'tabindex', index + 1 )
      })

    }

    const prev = () => {

        if ( lastActiveInput === 0 ) {

            lastActiveInput = inputs.length - 1
            inputs[lastActiveInput].focus()

        }

        else {

            lastActiveInput = lastActiveInput - 1
            inputs[lastActiveInput].focus()

        }

    }

    const next = () => {

        if ( lastActiveInput === inputs.length - 1 ) {

            lastActiveInput = 0
            inputs[lastActiveInput].focus()

        }

        else {

            lastActiveInput = lastActiveInput + 1
            inputs[lastActiveInput].focus()

        }

    }

    const guide = () => {

        getInputs()

        function findNext() {

            // Remove inputs with type other than those defined in inputTypes

            const inputList = activeAppointment.inputFields.filter( f => inputTypes.map( t => t.id ).includes(f.type) )

            for ( let i = 0; i < inputList.length; i++ ) {

                if ( inputList[i].isRequired && !inputList[i].value ) {

                    const currentInput = inputs.find( input => input.getAttribute('id') === inputList[i].id )
                    currentInput?.focus()
                    break

                }

            }

        }

        if ( activeAppointment.valid && !canSign ) {

            const next = $documents.find( a => !a.valid )

            if ( next ) setActive(next.id)

            setTimeout(() => { findNext() }, 300)

        }

        findNext()        

    }

    // Copies all input values from the 
    // active to the rest of the consents.

    const copyFields = () => {

        const signed = $documents.find( a => a.id === activeId ).inputFields
        const notSigned = $documents.filter( a => a.id != activeId )

        notSigned.forEach( item => {

            item.inputFields.forEach((input, index) => {

                let signedInput = signed.find(x => 
                    x.type === input.type && 
                    x.x === input.x && 
                    x.y === input.y)
                    
                if(!signedInput) {
                    return
                }

                input.value = signedInput.value

            })

        })

        $documents = $documents

    }

    // PDF

    let scale = 5
    let pages = []
    let pdfDoc = null

    const getPdf = async ( fileUrl ) => {

      if ( fileUrl ) {

        pages = []

        const request = await fetch(fileUrl)
        const pdfFile = await request.blob()

          const reader = new FileReader()
          reader.readAsDataURL(pdfFile) 

          reader.onload = async () => {

            const result = reader.result
            pdfDoc = await pdfjs.getDocument(result).promise
            const pagesNumber = pdfDoc.numPages

            const tempPages = [] 

            for( let i = 1; i <= pagesNumber; i ++ ) {

              const page = await pdfDoc.getPage(i)
              const view = page.getViewport({ scale })

              tempPages.push({
                id: `page_${i}`,
                page: i,
                canvasWidth: view.width,
                canvasHeight: view.height
              })

            }

            pages = tempPages

          }

      }

    }

    const loadPage = async ( p ) => {

      const page = await pdfDoc.getPage(p.page)
      const view = page.getViewport({ scale })
      const canv = document.getElementById(p.id)
      const ctx = canv.getContext('2d')

      page.render({
        viewport: view,
        canvasContext: ctx
      })

    }

    // Request appointments

    const getAppointments = async () => {

        const errors = []

        loader = true

        let idsList = await Promise.all(

            list.map( async ( id ) => {
 
                const request = await fetch(`${baseUrl}/documents/${id}/data`)
                const response = await request.json()

                if ( request.status === 200 ) {

                    if ( !response.isClosed ) return response

                    else errors.push({

                        title: response.title,
                        error: response.statusReason

                    })

                }

                else errors.push({
                    title: '/',
                    errors: response.message
                })

            })
        )

        loader = false

        idsList = idsList.filter( item => item != null )

        // Sort inputs by input.y values

        const compare = (a,b) => {

            const valueA = a.y
            const valueB = b.y
            const valueXA = a.x
            const valueXB = b.x

            let comparasion = 0

            if ( valueA > valueB ) {
                comparasion = 1
            }

            else if ( valueA < valueB ) {
                comparasion = -1
            }

            return comparasion

        }

        idsList.forEach( doc => {

            doc.valid = false

            // Remove inputs with type other than those defined in inputTypes

            doc.inputFields = doc.inputFields.filter( f => inputTypes.map( t => t.id ).includes(f.type) )

            // Sort Inputs

            doc.inputFields.sort(compare)

            doc.inputFields.forEach( field => {   

                if ( field.type === 4 ){
                    const currentDate = new Date()
                    field.value = `${currentDate.getDate()} ${currentDate.toLocaleString('default', { month: 'long' })}, ${currentDate.getFullYear() }`
                } 
                
            })

        })

        activeId = idsList.length > 0 ? idsList[0].id ? idsList[0].id : null : null
        activeAppointment = idsList.length > 0 ? idsList[0] ? idsList[0] : null : null
        errorList = errors
        $documents = idsList

        await getPdf( activeAppointment.fileUrl )

        // Set tabindex to inputs and focus first input

        getInputs()

    }

    let requestPending = false

    const sendAppointments = async () => {

        let data = []

        $documents.forEach( item => {

            data.push({
                id: item.id,
                title: item.title,
                signedInPerson: signedInPerson,
                inputFields: item.inputFields
            })

        })

        requestPending = true
        const result = await fetch( `${baseUrl}/documents/${signedInPerson ? 'bulk-sign' : 'sign'}`, {
            method: 'POST',
            headers: await postHeaders(baseUrl),
            body: JSON.stringify(signedInPerson ? data : data[0])
        })

        if ( result.status === 200 ) {
            $signedDocuments = await result.json()
        }

        goSign()

        requestPending = false

    }

    // Go to the next step

    const goSign = () => {

        stepsStore.update( steps => {

            let copiedSteps = [...steps]
            copiedSteps[1].done = true

            return copiedSteps

        })

    }

    const setUserActive = () => $userActive = true
    const setUserPasive = () => $userActive = false

    onMount( async() => {

        await getAppointments()

        if(mobileCheck)
        {
            let canvasElement = document.getElementById('canvas')

            Panzoom(canvasElement, {
                excludeClass: "input",
                exclude: [document.getElementById('modal-portal')],
                minScale: 1
            })

            canvasElement.addEventListener( 'panzoomstart', setUserActive )
            canvasElement.addEventListener( 'panzoomend', setUserPasive )
        }
    })

</script>

<style>

    .docs-page {
        @apply relative;
    }

    .docs-page-body {
        @apply h-full pb-0 relative overflow-hidden;
    }

    .flexy-sidebar {
        @apply w-104 transform transition-transform duration-300 -translate-x-96 min-w-104 h-fixed-bar bg-white fixed left-0 z-20 shadow-x-xl hidden;
    }

    .sidebar-icon {
        @apply w-10 h-10 bg-ch-blue absolute top-1/2 right-0 transform -translate-y-1/2 translate-x-1/2 rounded-full flex items-center justify-center;
    }

    .flexy-sidebar-content {
        @apply h-fixed-bar overflow-y-auto p-10 pt-0;
    }

    .flexy-sidebar-content-head {
        @apply py-4 pt-10 flex justify-between sticky top-0 z-10 bg-white;
    }

    .flexy-sidebar-content-head-title {
        @apply text-lg text-gray-800 tracking-widest;
    }

    .flexy-sidebar-content-head-title-closed {
        @apply text-lg text-red-600 tracking-widest;
    }

    .flexy-sidebar-content-head-count {
        @apply text-lg text-gray-800 tracking-widest;
    }

    .green-span {
        @apply text-green-400;
    }

    .red-span {
        @apply text-red-600;
    }

    .flexy-sidebar-content-body {
        @apply grid gap-4 relative;
    }

    .flexy-sidebar-content-body-loader {
        @apply w-full h-auto py-10 flex flex-col items-center justify-center bg-white;
    }

    .v-space-4 {
        @apply mb-4;
    }

    .mobile-slider {
        @apply w-full h-auto fixed z-30 top-30 bg-white border-b border-solid border-gray-300;
    }

    .mobile-slider-head {
        @apply p-4 flex items-center bg-white border-b border-solid border-gray-300;
    }

    .mobile-slider-head-icon {
        @apply w-8 h-8 flex items-center justify-center rounded-full transition-transform duration-150;
    }

    .mobile-slider-head-icon-open {
        @apply transform rotate-180;
    }

    .mobile-slider-head-icon-image {
        @apply transform transition-transform duration-150;
    }

    .mobile-slider-body {
        @apply h-0 py-0 px-4 grid grid-flow-col gap-4 overflow-y-hidden overflow-x-auto transition-all duration-300;
    }

    .mobile-slider-open {
        @apply h-48 py-4;
    }

    .docs-canvas-wrap {
        @apply w-full max-h-full pt-30 relative overflow-auto outline-none bg-gray-100 bg-center bg-no-repeat;
    }

    .docs-canvas {
        @apply flex flex-col items-center justify-center;
    }

    .docs-canvas-content {
        @apply w-full relative;
    }

    .docs-canvas-form {
        @apply w-full h-full absolute top-0;
    }

    .docs-canvas-input {
        @apply text-xxxs leading-normal w-full h-full p-0 absolute border border-solid border-ch-blue rounded bg-blue-200;
    }

    .docs-canvas-checkbox {
        @apply w-full h-full absolute border-solid border-ch-blue rounded bg-blue-200;
        outline: 3px solid #2A4365;
    }

    .docs-canvas-date {
        @apply w-full h-full absolute flex items-center px-4 border border-solid border-gray-400 rounded;
    }

    .docs-canvas-date-text {
        @apply whitespace-no-wrap text-xxs flex-grow;
    }

    .required {
        @apply border-red-500 bg-red-200;
    }

    .docs-page-footer {
        @apply w-full h-20 px-4 flex items-center sticky bottom-0 justify-end bg-white border-t border-solid border-gray-300 bg-white z-20;
    }

    .docs-page-footer-guide {
        @apply flex;
    }

    .h-space-4 {
        @apply ml-4;
    }

    .grow {
        @apply flex-grow;
    }

/* MD breakpoint */

@media (min-width: 768px) {

    .docs-page {
        @apply overflow-hidden grid grid-rows-page;
    }

    .docs-page-body {
        @apply flex pt-0 overflow-hidden;
    }

    .flexy-sidebar {
        @apply block;
    }

    .mobile-slider {
        @apply hidden;
    }

    .docs-canvas-wrap {
        @apply w-full max-h-full pt-0 relative overflow-auto outline-none bg-gray-100 bg-center bg-no-repeat;
    }

    .docs-canvas {
        @apply p-10 pl-20;
    }

    .docs-page-footer {
        @apply px-10;
    }

    .docs-canvas-input {
        @apply text-sm w-full h-full px-2 absolute border-2 border-solid border-ch-blue rounded bg-blue-200;
    }

    .docs-canvas-date-text {
        @apply text-sm;
    }

    .required {
        @apply border-red-500 bg-red-200;
    }

    .mobile {
        display: none;
    }

}

/* LG breakpoint */

@media (min-width: 1280px) {

    .flexy-sidebar {
        @apply relative shadow-none translate-x-0;
    }

    .sidebar-icon {
        @apply hidden;
    }

    .docs-canvas {
        @apply pl-10;
    }

}

    .flexy-sidebar:hover {
        @apply translate-x-0;
    }

</style>

<div in:fade class="docs-page" >

    <div class="docs-page-body" >

        <!-- flexy Sidebar -->

        <div class="flexy-sidebar" >

            <!-- Sidebar Appointments Icon -->

            <div class="sidebar-icon"
            
            >
        
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="3" y="1" width="18" height="22">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M7 3C7 1.89543 7.89543 1 9 1H15C16.1046 1 17 1.89543 17 3H18C18.7956 3 19.5587 3.31607 20.1213 3.87868C20.6839 4.44129 21 5.20435 21 6V20C21 20.7957 20.6839 21.5587 20.1213 22.1213C19.5587 22.6839 18.7957 23 18 23H6C5.20435 23 4.44129 22.6839 3.87868 22.1213C3.31607 21.5587 3 20.7957 3 20V6C3 5.20435 3.31607 4.44129 3.87868 3.87868C4.44129 3.31607 5.20435 3 6 3H7ZM15 7C16.1046 7 17 6.10457 17 5H18C18.2652 5 18.5196 5.10536 18.7071 5.29289C18.8946 5.48043 19 5.73478 19 6V20C19 20.2652 18.8946 20.5196 18.7071 20.7071C18.5196 20.8946 18.2652 21 18 21H6C5.73478 21 5.48043 20.8946 5.29289 20.7071C5.10536 20.5196 5 20.2652 5 20V6C5 5.73478 5.10536 5.48043 5.29289 5.29289C5.48043 5.10536 5.73478 5 6 5H7C7 6.10457 7.89543 7 9 7H15ZM9 5V4V3H15V4V5H9ZM9 16C8.44772 16 8 16.4477 8 17C8 17.5523 8.44772 18 9 18H15C15.5523 18 16 17.5523 16 17C16 16.4477 15.5523 16 15 16H9ZM8 14C8 13.4477 8.44772 13 9 13H15C15.5523 13 16 13.4477 16 14C16 14.5523 15.5523 15 15 15H9C8.44772 15 8 14.5523 8 14ZM9 10C8.44772 10 8 10.4477 8 11C8 11.5523 8.44772 12 9 12H15C15.5523 12 16 11.5523 16 11C16 10.4477 15.5523 10 15 10H9Z" fill="#707881"/>
                    </mask>
                    <g mask="url(#mask0)">
                    <rect width="24" height="24" fill="white"/>
                    </g>
                </svg>
                
        
            </div>

            <!-- Sidebar content - overflowing container -->

            <div class="flexy-sidebar-content hide-scroll" >

                <!-- Sidebar head -->

                {#if $documents.length > 0 }

                <div class="flexy-sidebar-content-head" >

                    <p class="flexy-sidebar-content-head-title" >Consents to Fill</p>

                    <p class="flexy-sidebar-content-head-count" >{ $documents.filter( a => !a.valid ).length } / <span class="green-span" >{ list.length }</span></p>

                </div>

                {/if}

                <!-- Sidebar body -->

                <div class="flexy-sidebar-content-body" >

                    <!-- Appointments -->

                    {#each $documents as appointment }

                        <AppointmentCard

                        canSign={canSign}
                        id={appointment.id}
                        valid={appointment.valid}
                        title={appointment.title}
                        status={appointment.status}
                        active={ appointment.id === activeId }
                        filledFields={ appointment.inputFields.filter( f => f.isRequired && f.value ).length }
                        requiredFields={ appointment.inputFields.filter( f => f.isRequired ).length }

                        on:copy={ copyFields }
                        on:setActive={ (e) => setActive(e.detail.id) }
                        
                        />

                    {:else}

                        {#if loader }

                        <div class="flexy-sidebar-content-body-loader" >

                            <p class="v-space-4" >Fetching appointments...</p>

                            <svg width="38" height="38" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" stroke="#082E45">
                                <g fill="none" fill-rule="evenodd">
                                    <g transform="translate(1 1)" stroke-width="2">
                                        <circle stroke-opacity=".5" cx="18" cy="18" r="18"/>
                                        <path d="M36 18c0-9.94-8.06-18-18-18">
                                            <animateTransform
                                                attributeName="transform"
                                                type="rotate"
                                                from="0 18 18"
                                                to="360 18 18"
                                                dur="1s"
                                                repeatCount="indefinite"/>
                                        </path>
                                    </g>
                                </g>
                            </svg>

                        </div>
                        
                        {/if}

                    {/each}

                    <!-- Errors -->

                    {#if errorList.length > 0 }

                        <div class="flexy-sidebar-content-head" >

                            <p class="flexy-sidebar-content-head-title" >Closed Consents</p>

                            <p class="flexy-sidebar-content-head-count" >{errorList.length} / {list.length}</p>

                        </div>

                    {/if}

                    {#each errorList as error }
 
                        <ErrorCard error={error} />

                    {/each}

                </div>

            </div>

        </div>

        <!-- Mobile appointments slider -->

        {#if !$userActive}

        <div class="mobile-slider" >

            <div>
                
                <div 
                
                class="mobile-slider-head" 
                on:click={() => openMenu = !openMenu} 
                
                >

                    {#if $documents.length > 0 }

                        <p class="flexy-sidebar-content-head-title" >Consents to Fill</p>

                        <p class="flexy-sidebar-content-head-count h-space-4 grow" ><span class="green-span" >{ $documents.filter( a => !a.valid ).length } </span> / { list.length }</p>

                    {:else if $documents.length === 0 && errorList.length > 0 }

                        <p class="flexy-sidebar-content-head-title-closed" >These consents are closed</p>

                        <p class="flexy-sidebar-content-head-count h-space-4 grow" ><span class="red-span" >{ errorList.length }</span> / { list.length }</p>

                    {/if}

                    <div 
                    
                    class="mobile-slider-head-icon"
                    class:mobile-slider-head-icon-open={!openMenu} 
                    
                    >

                        <svg 

                        width="20" 
                        height="20" 
                        viewBox="0 0 20 20" 
                        fill="none" 
                        xmlns="http://www.w3.org/2000/svg"
                        class="mobile-slider-head-icon-image"
                        
                        >

                            <g clip-path="url(#clip0)">
                            <path d="M18.3334 13.334L10 5.00065L1.66671 13.334" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </g>
                            <defs>
                            <clipPath id="clip0">
                            <rect width="20" height="20" fill="white" transform="translate(20 20) rotate(180)"/>
                            </clipPath>
                            </defs>
                        </svg>

                    </div>

                </div>

                <div 
                
                class:mobile-slider-open={ openMenu }
                class="mobile-slider-body hide-scroll" 
                
                >

                    {#each $documents as appointment }

                        <AppointmentCard

                        canSign={canSign}
                        id={appointment.id} 
                        valid={appointment.valid}
                        title={appointment.title}
                        status={appointment.status}
                        active={ appointment.id === activeId }
                        filledFields={ appointment.inputFields.filter( f => f.isRequired && f.value ).length }
                        requiredFields={ appointment.inputFields.filter( f => f.isRequired ).length }

                        on:copy={ copyFields }
                        on:setActive={ (e) => setActive(e.detail.id)  }
                        
                        />

                    {:else}

                        {#if loader }

                            <div class="flexy-sidebar-content-body-loader" >

                                <p class="v-space-4" >Fetching appointments...</p>

                                <svg width="38" height="38" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" stroke="#082E45">
                                    <g fill="none" fill-rule="evenodd">
                                        <g transform="translate(1 1)" stroke-width="2">
                                            <circle stroke-opacity=".5" cx="18" cy="18" r="18"/>
                                            <path d="M36 18c0-9.94-8.06-18-18-18">
                                                <animateTransform
                                                    attributeName="transform"
                                                    type="rotate"
                                                    from="0 18 18"
                                                    to="360 18 18"
                                                    dur="1s"
                                                    repeatCount="indefinite"/>
                                            </path>
                                        </g>
                                    </g>
                                </svg>

                            </div>

                        {/if}

                    {/each}

                    {#each errorList as error }
 
                        <ErrorCard error={error} />

                    {/each}

                </div>

            </div>

        </div>

        {/if}

        <!-- Canvas with forms -->

        <div 
        
        class="docs-canvas-wrap" 
        
        >

            { #if !loader && activeAppointment }

                <div 
                
                id="canvas" 
                class="docs-canvas" 
                
                >

                    {#each $documents.filter( a => a.id === activeAppointment?.id ) as appointment (appointment.id) }

                        {#each pages as image, index }

                            <div 
                            
                            class="docs-canvas-content"
                            id={`page-${ index + 1 }`}
                        
                            bind:clientWidth={docW} 
                            bind:clientHeight={docH} 
                            in:fly={{y:100, duration: 500}} 
                            
                            >

                                <Page page={image} action={loadPage} />

                                <form id={`form-${ index + 1 }`} class="docs-canvas-form" >

                                    {#each appointment.inputFields.filter( i => parseInt(i.pageNumber) === ( index + 1 ) ) as input, inputIndex }

                                            {#if !inputTypes.map( t => t.id ).includes(input.type) }
                                                <div></div>
                                            {/if}

                                            <!-- Text Inputs -->

                                            {#if inputTypes.find( t => t.id === input.type ).id === 2 }

                                                <input 
                                                
                                                type="text"
                                                id={input.id}
                                                class="input docs-canvas-input"
                                                class:required={input.isRequired}
                                                style="
                                                  top: {calibrate(input.y, image.canvasHeight / scale, docH)}px;
                                                  left: {calibrate(input.x, image.canvasWidth / scale, docW)}px;
                                                  width: {calibrate(input.width, image.canvasWidth / scale, docW)}px; 
                                                  height: {calibrate(input.height, image.canvasHeight / scale, docH)}px;
                                                "
                                                
                                                value={input.value}

                                                on:input={ (e) => input.value = e.target.value }
                                                
                                                >

                                            {/if}

                                            <!-- Checkbox Inputs -->

                                            {#if inputTypes.find( t => t.id === input.type ).id === 3 }
                                    
                                                <input 
                                                
                                                id={input.id}
                                                type="checkbox"
                                                class="input docs-canvas-checkbox"
                                                class:required={input.isRequired}
                                                style="
                                                    {input.isRequired ? 'outline: 3px solid #f56565 !important;' : ''}
                                                    top: {calibrate(input.y, image.canvasHeight / scale, docH)}px;
                                                    left: {calibrate(input.x, image.canvasWidth / scale, docW)}px;
                                                    width: {calibrate(input.width, image.canvasWidth / scale, docW)}px; 
                                                    height: {calibrate(input.height, image.canvasHeight / scale, docH)}px;
                                                "
                                                
                                                bind:checked={input.value}

                                                on:change={() => checkInputs()}
                                                
                                                >

                                            {/if}

                                            <!-- Date Readonly -->

                                            {#if inputTypes.find( t => t.id === input.type ).id === 4 }

                                                <div
                                                
                                                id={input.id}
                                                value={input.value}
                                                class="input docs-canvas-date"
                                                style="
                                                  top: {calibrate(input.y, image.canvasHeight / scale, docH)}px;
                                                  left: {calibrate(input.x, image.canvasWidth / scale, docW)}px;
                                                  width: {calibrate(input.width, image.canvasWidth / scale, docW)}px; 
                                                  height: {calibrate(input.height, image.canvasHeight / scale, docH)}px;
                                                "
                                                
                                                >
                                                    <p class="docs-canvas-date-text" >{ input.value }</p>
                                                </div>

                                            {/if}

                                            <!-- Signature Inputs -->

                                            {#if inputTypes.find( t => t.id === input.type ).id === 1 }
                                    
                                                <SignModal
                                                
                                                id={input.id}
                                                bind:value={input.value}
                                                required={input.isRequired}
                                                on:sign={(e) => input.value = e.detail.signature}
                                                sClass="input"
                                                sStyle="
                                                  top: {calibrate(input.y, image.canvasHeight / scale, docH)}px;
                                                  left: {calibrate(input.x, image.canvasWidth / scale, docW)}px;
                                                  width: {calibrate(input.width, image.canvasWidth / scale, docW)}px; 
                                                  height: {calibrate(input.height, image.canvasHeight / scale, docH)}px;
                                                "

                                                />

                                            {/if}
                                    
                                    {/each}

                                </form>

                            </div>

                        {/each}

                    {/each}

                </div>

            {:else}

                <div class="flexy-sidebar-content-body-loader mobile" >

                    <p class="v-space-4" >Fetching appointments...</p>

                    <svg width="38" height="38" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" stroke="#082E45">
                        <g fill="none" fill-rule="evenodd">
                            <g transform="translate(1 1)" stroke-width="2">
                                <circle stroke-opacity=".5" cx="18" cy="18" r="18"/>
                                <path d="M36 18c0-9.94-8.06-18-18-18">
                                    <animateTransform
                                        attributeName="transform"
                                        type="rotate"
                                        from="0 18 18"
                                        to="360 18 18"
                                        dur="1s"
                                        repeatCount="indefinite"/>
                                </path>
                            </g>
                        </g>
                    </svg>

                </div>

            {/if}

        </div>

    </div>

    <!-- Footer -->

    <div class="docs-page-footer" >

        { #if !canSign && activeId }

        <div class="docs-page-footer-guide" transition:fly >

            <!-- <button class="b-regular" on:click={prev} >Prev</button>

            <button class="b-regular h-space-4" on:click={next} >Next</button> -->

            <button class="b-regular h-space-4" on:click={guide} >Guide Me</button>

        </div>

        {:else if activeId }

        <div>

            <button class="b-main" on:click={sendAppointments} disabled={requestPending}>
                
                Send to Clinic &nbsp;

                {#if requestPending }

                    <svg width="24" height="24" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" stroke="#FFF" class="ml-4" >
                        <g fill="none" fill-rule="evenodd">
                            <g transform="translate(1 1)" stroke-width="2">
                                <circle stroke-opacity=".5" cx="18" cy="18" r="18"/>
                                <path d="M36 18c0-9.94-8.06-18-18-18">
                                    <animateTransform
                                        attributeName="transform"
                                        type="rotate"
                                        from="0 18 18"
                                        to="360 18 18"
                                        dur="1s"
                                        repeatCount="indefinite"/>
                                </path>
                            </g>
                        </g>
                    </svg>

                {/if}
            
            </button>

        </div>

        {/if}

    </div>

</div>
